import useViewModel from "./viewModel";
import React from "react";
import View from "./view";

const Subscriptions = () => {
  const viewModel = useViewModel();

  return <View {...viewModel} />;
};

export default Subscriptions;
